// extracted by mini-css-extract-plugin
module.exports = {"overAll":"candidateresumetab_overAll__38KG-","resumeStyleOne":"candidateresumetab_resumeStyleOne__RLFTT"};